import { render, staticRenderFns } from "./AuthorWritingFrequency.vue?vue&type=template&id=60b91fdb&scoped=true"
import script from "./AuthorWritingFrequency.vue?vue&type=script&lang=js"
export * from "./AuthorWritingFrequency.vue?vue&type=script&lang=js"
import style0 from "./AuthorWritingFrequency.vue?vue&type=style&index=0&id=60b91fdb&prod&scoped=true&lang=css"
import style1 from "./AuthorWritingFrequency.vue?vue&type=style&index=1&id=60b91fdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b91fdb",
  null
  
)

export default component.exports